<template>
  <div class="trips page-component">
    <div class="container">
      <h1 class="text-center">{{ title }}</h1>
      <div class="grid-full-width">
        <card v-for="trip in trips"
              :key="trip.uid"
              :modifier-classes="['card--h card--skeleton']"
              :target='"/#/trip/" + trip.uid'
        >
          <template v-slot:card-image>
            <prismic-image :field="trip.thumbnail"></prismic-image>
          </template>
          <template v-slot:card-content>
            <span class="chip chip--borderless">{{ trip.teaserword }}</span>
            <h3>{{ trip.title[0].text }}</h3>
            <p class="lead-text">{{ $prismic.richTextAsPlain(trip.shortdescription) }}</p>
          </template>
          <template v-slot:card-action>
            <a :href='"/#/trip/" + trip.uid' ></a>
          </template>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../EventBus'
import Card from '../../elements/Card.vue'

export default {
  name: 'Trips',
  props: ['title', 'lead'],
  components: {
    Card
  },
  data () {
    return {
      trips: null
    }
  },
  methods: {
    async getContent(language) {
      let document = await this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'trip'), {lang: language}
      )
      if (document) {
        this.trips = document.results.map(result => result = {
          uid: result.uid,
          title: result.data.title,
          teaserword: result.data.teaserword,
          thumbnail: result.data.thumbnail,
          shortdescription: result.data.shortdescription,
          description: result.data.description,
          stationList: result.data.station
        })
      }
    }
  },
  async created() {
    await this.getContent(window.KriensTourismus.language)

    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  }
}
</script>